import FullTable from 'js/components/full-table/index.js'
import {openModalConfirmRemove} from 'js/services/modals.js'

import template from './_table.pug'

export default Vue.extend({
  template: template(),
  components: {
    FullTable
  },
  props: {
    customers: {
      type: Array,
      required: true
    },
    meta: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showFilters: true,
      filters: {status: '', name: '', customerId: [], userId: null},
      lastQueryOptions: null // guarda los últimos filtros aplicados
    }
  },
  computed: {
    canEdit() {
      return this.$user.permissions.includes('EDIT_CUSTOMERS')
    },

    canDelete() {
      return this.$user.permissions.includes('DELETE_CUSTOMERS')
    },

    canCreateCustomers() {
      return this.$user.permissions.includes('CREATE_CUSTOMERS')
    },

    defaultOrder() {
      return {currentField: 'name', currentDir: 'asc'}
    },

    statusOptions() {
      return [
        {label: this.t('filters.status.all'), value: ''},
        {label: this.t('filters.status.active'), value: CUSTOMER_STATUSES.ACTIVE},
        {label: this.t('filters.status.inactive'), value: CUSTOMER_STATUSES.INACTIVE},        
        {label: this.t('filters.status.no_campaigns'), value: CUSTOMER_STATUSES.NO_CAMPAIGNS}
      ]
    },

    filterButtonParams() {
      if (this.showFilters) {
        return {class: 'active', icon: 'angle-up'}
      }

      return {class: '', icon: 'angle-down'}
    }
  },
  methods: {
    getData(queryOptions) {
      // si borramos un elemento y recargamos, usamos los últimos filtros aplicados
      this.$emit('load-data', queryOptions || this.lastQueryOptions)

      if (queryOptions) this.lastQueryOptions = queryOptions
    },

    t(key, options = {}) {
      return this.$t(`customers.index.${key}`, options)
    },

    noHaveCampaigns(status) {
      return status === CUSTOMER_STATUSES.NO_CAMPAIGNS
    },

    getClassByStatus(status) {      
      switch (status) {
        case CUSTOMER_STATUSES.ACTIVE:
          return 'table-tag--success'
        case CUSTOMER_STATUSES.INACTIVE:
          return 'table-tag--gray'        
        case CUSTOMER_STATUSES.NO_CAMPAIGNS:
          return 'table-tag--yellow-light'
        case CUSTOMER_STATUSES.CREATION:
          return 'table-tag--yellow-light'
        default:
          return ''
      }
    },

    getIconByStatus(status) {
      switch (status) {
        case CUSTOMER_STATUSES.ACTIVE:
          return 'check'        
        case CUSTOMER_STATUSES.INACTIVE:
          return 'close'
        case CUSTOMER_STATUSES.NO_CAMPAIGNS:
          return 'ban'        
        case CUSTOMER_STATUSES.CREATION:
          return 'clock'
        default:
          return ''
      }
    },

    avatarInitials(customer) {
      return customer.name ? customer.name[0] : '-'
    },

    confirmDelete(customer) {
      openModalConfirmRemove(
        this.t('confirmationModal.remove.title'),
        this.t('confirmationModal.remove.body', {name: customer.name}),
        this.t('confirmationModal.remove.okButton')
      ).then(() => this.destroy(customer))
    },

    destroy(customerId) {
      API.customers.destroy(customerId.id).then(() => {
        this.getData()
        this.$notifications.success(this.t('succesfullyDeleted'))
      })
    }
  }
})
